export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";

export const ISO_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const PAYMENT_STATUS = {
  ALL: null,
  PAID: 1,
  UNDERPAID: 2,
  UNPAID: 0,
  OVERPAID: 3,
} as const;

export type PaymentStatusFilter =
  (typeof PAYMENT_STATUS)[keyof typeof PAYMENT_STATUS];

export const PAYMENT_STATUS_OPTIONS = [
  { value: PAYMENT_STATUS.ALL, label: "Tất cả", field: "all" },
  { value: PAYMENT_STATUS.UNPAID, label: "Chưa thanh toán", field: "unpaid" },
  { value: PAYMENT_STATUS.PAID, label: "Thanh toán đủ", field: "paid" },
  {
    value: PAYMENT_STATUS.UNDERPAID,
    label: "Thanh toán thiếu",
    field: "underpaid",
  },
  {
    value: PAYMENT_STATUS.OVERPAID,
    label: "Thanh toán thừa",
    field: "overpaid",
  },
] as const;

export const QR_TIME_PRESETS = [
  { value: "TODAY", label: "Hôm nay", days: 0 },
  { value: "7DAYS", label: "7 ngày", days: 7 },
  { value: "30DAYS", label: "30 ngày", days: 30 },
  { value: "90DAYS", label: "90 ngày", days: 90 },
  { value: "1YEAR", label: "1 năm", days: 365 },
  { value: "CUSTOM", label: "Tùy chọn", days: null },
] as const;

export type QrTimePreset = (typeof QR_TIME_PRESETS)[number]["value"];

export const DATA_SOURCE_OPTIONS = [
  { value: "invoice", label: "Hóa đơn" },
  { value: "fuel_log", label: "Xăng dầu" },
] as const;

export type DataSourceValue = (typeof DATA_SOURCE_OPTIONS)[number]["value"];

export const DEFAULT_DATA_SOURCE_VALUES: DataSourceValue[] =
  DATA_SOURCE_OPTIONS.map((item) => item.value);

export interface PaymentSummaryCounts {
  all: number;
  paid: number;
  underpaid: number;
  unpaid: number;
  overpaid: number;
}

export const EMPTY_PAYMENT_SUMMARY: PaymentSummaryCounts = {
  all: 0,
  paid: 0,
  underpaid: 0,
  unpaid: 0,
  overpaid: 0,
};
